module.exports = __webpack_public_path__ + "img/medal.e946e573.svg";